// variable = Skysight's emitted key; dataField = per-altitude slice field;
// grid value = how the contour grid cell is computed; scale = palette factory;
// unit = which units.* key feeds convertUnit; hasBarbs = barbs drawn on this tab;
// splitAxis = false → linear full-range altitude axis; true → split axis.
export const FIELDS = {
  overview:   { variable: 'cldcover',    label: 'Overview',          dataField: 'ti',    unit: 'vert', scaleKey: 'cldcover', hasBarbs: true,  splitAxis: true,  isOverview: true },
  ti:         { variable: 'ti',          label: 'Thermal Strength',  dataField: 'ti',    unit: 'vert', scaleKey: 'ti',       hasBarbs: false, splitAxis: false },
  lapserate:  { variable: 'lapserate',   label: 'Lapse Rate',        dataField: 'lapse', unit: null,   scaleKey: 'lapse',    hasBarbs: false, splitAxis: true },
  temperature:{ variable: 'temperature', label: 'Temperature',       dataField: 'temp',  unit: 'temp', scaleKey: 'temp',     hasBarbs: false, splitAxis: true },
  rh:         { variable: 'rh',          label: 'Relative Humidity', dataField: 'rh',    unit: null,   scaleKey: 'rh',       hasBarbs: false, splitAxis: true },
  wind:       { variable: 'wind',        label: 'Wind Speed',        dataField: 'wind',  unit: 'spd',  scaleKey: 'wind',     hasBarbs: true,  splitAxis: false },
  cldfra:     { variable: 'cldfra',      label: 'Cloud Cover',       dataField: 'cldfra',unit: null,   scaleKey: 'cldfra',   hasBarbs: true,  splitAxis: false },
};
// Tab order shown in the UI (matches Skysight left→right):
export const TAB_ORDER = ['overview', 'ti', 'lapserate', 'temperature', 'rh', 'wind', 'cldfra'];

export const MARGIN = { top: 5, right: 25, bottom: 50, left: 45 };
export const DEFAULT_ALT = 9000;          // metres ceiling
export const ALT_OPTIONS = [9000, 6000, 4500, 3000, 1500]; // GND–<x>m select (confirm vs bundle ~line 2086-2138)

// Meaningful altitude ceiling per tab — Skysight auto-sets this on tab change so
// each field shows useful data (bundle x$/E9, main bundle):
//   cldcover (Overview) / cldfra (Cloud Cover) → 9000 m (full column)
//   ti (Thermal Strength) → smallest 3000 + k·1000 m exceeding max(pblh, zsfclcl)
//     so the thermal dome fills the chart instead of sitting tiny at the bottom
//   temperature / rh / lapserate / wind → 6000 m
// `variable` here is the TAB KEY (overview/ti/lapserate/temperature/rh/wind/cldfra).
export function altitudeForVariable(variable, timeSteps = []) {
  if (variable === 'overview' || variable === 'cldfra') return 9000;
  if (variable === 'ti') {
    const maxH = (timeSteps || []).reduce(
      (m, t) => Math.max(m, parseFloat(t.pblh) || 0, parseFloat(t.zsfclcl) || 0),
      0,
    );
    let n = 3000;
    while (maxH > n) n += 1000;
    return n;
  }
  return 6000; // temperature, rh, lapserate, wind
}
